'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styles = require('./styles.css');

var _styles2 = _interopRequireDefault(_styles);

var _classnames3 = require('classnames');

var _classnames4 = _interopRequireDefault(_classnames3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LoadingIndicator = function LoadingIndicator(_ref) {
  var _classnames, _classnames2;

  var env = _ref.env,
      size = _ref.size,
      children = _ref.children;

  var spinnerClassName = (0, _classnames4.default)(_styles2.default['loading--spinner'], (_classnames = {}, _defineProperty(_classnames, _styles2.default['loading--spinner__light'], env === 'light'), _defineProperty(_classnames, _styles2.default['loading--spinner__dark'], env === 'dark'), _defineProperty(_classnames, _styles2.default['loading--spinner__' + size], true), _classnames));

  var textClassName = (0, _classnames4.default)(_styles2.default['loading--text'], (_classnames2 = {}, _defineProperty(_classnames2, _styles2.default['loading--text__light'], env === 'light'), _defineProperty(_classnames2, _styles2.default['loading--text__dark'], env === 'dark'), _defineProperty(_classnames2, _styles2.default['loading--text__' + size], true), _classnames2));

  return _react2.default.createElement(
    'div',
    { className: _styles2.default.loading },
    _react2.default.createElement('div', { className: spinnerClassName }),
    children && _react2.default.createElement(
      'div',
      { className: textClassName },
      children
    )
  );
};

LoadingIndicator.propTypes = {
  env: _react.PropTypes.oneOf(['light', 'dark']),
  size: _react.PropTypes.oneOf(['x-large', 'large', 'medium', 'small']),
  children: _react.PropTypes.node
};

LoadingIndicator.defaultProps = {
  env: 'light',
  size: 'medium'
};

exports.default = LoadingIndicator;